import {ScrollLock} from '../utils/scroll-lock';
import {FocusLock} from '../utils/focus-lock';


export class Burger {
  constructor() {
    this._header = document.querySelector('[data-header]');
    this._burger = document.querySelector('[data-burger]');
    this._logo = document.querySelector('[data-header-logo]');
    this._scrollLock = new ScrollLock();
    this._focusLock = new FocusLock();
    this._isMenuOpen = false;

    this._onBurgerClick = this._onBurgerClick.bind(this);
    this._onDocumentKeydown = this._onDocumentKeydown.bind(this);
    this._onDocumentClick = this._onDocumentClick.bind(this);
    this._ifWindowResized = this._ifWindowResized.bind(this);
  }

  init() {
    if (!this._burger) {
      return;
    }
    this._burger.addEventListener('click', this._onBurgerClick);
  }

  _openMenu() {
    this._isMenuOpen = true;
    this._header.classList.remove('is-closed');
    this._header.classList.add('is-opened');
    this._scrollLock.disableScrolling();
    document.addEventListener('keydown', this._onDocumentKeydown);
    document.addEventListener('click', this._onDocumentClick);
    window.addEventListener('resize', this._ifWindowResized);
    this._focusLock.lock('[data-header]');
  }

  _closeMenu() {
    this._isMenuOpen = false;
    this._header.classList.remove('is-opened');
    this._header.classList.add('is-closed');
    this._scrollLock.enableScrolling();
    this._focusLock.unlock('[data-header]');
    document.removeEventListener('keydown', this._onDocumentKeydown);
    document.removeEventListener('click', this._onDocumentClick);
    window.removeEventListener('resize', this._ifWindowResized);
  }

  _onBurgerClick() {
    if (this._isMenuOpen) {
      this._closeMenu();
    } else {
      this._openMenu();
    }
  }

  _onDocumentKeydown(evt) {
    if (evt.key === 'Escape') {
      this._closeMenu();
    }
  }

  _onDocumentClick(evt) {
    if (evt.target.hasAttribute('data-close-menu')) {
      this._closeMenu();
    }
  }

  _ifWindowResized() {
    let width = document.body.clientWidth;
    if (width > 1023) {
      this._closeMenu();
    }
  }
}
